import Event from "./Event";
import { apiURL } from "../helpers/url";

class Preview extends Event {
    constructor() {
        super();
        this.apiURL = apiURL();
        this.preview = {};
        this.promises = {
            fetching: null
        };

        // We register these in widgets.js
        this.widget = {
            open: null,
            close: null
        };
    }

    // Creating a global instance
    static createInstance() {
        return new this();
    }

    open(bookId) {
        if (this.widget.open) {
            document.body.classList.add("fixed");
            this.widget.open(bookId);
        }
    }

    close() {
        if (this.widget.open) {
            document.body.classList.remove("fixed");
            this.widget.close();
        }
    }

    /**
     * Fetch Preview item
     *
     * Preview returns pending Promise if API request is pending
     *
     * @returns {Promise} Promise object with status and data
     */
    fetchPreview(bookId) {
        this.publish("itemsFetching");

        // If fetching is already underway we return promise
        if (this.promises.fetching) return this.promises.fetching;

        this.promises.fetching = fetch(this.apiURL + "/preview/" + bookId)
            .then(response => {
                return response.text().then(text => {
                    return {
                        status: response.status,
                        content: text
                    };
                });
            })
            .then(response => {
                let content = response.status < 300 ? JSON.parse(response.content) : null;

                if (content) {
                    this.preview = content;
                    this.publish("itemsFetched");
                }
                this.promises.fetching = null;

                return {
                    status: response.status,
                    content: content
                };
            })
            .catch(error => {
                this.promises.fetching = null;
                return {
                    status: 600,
                    error: error
                };
            });

        return this.promises.fetching;
    }
}

export default Preview;
